import React from "react";

const UserContext = React.createContext({
  refreshUser: () => {},
});

export default UserContext;
